module.exports = __webpack_public_path__ + "files/41cc7b19ddb61fcd4d8c1e04f2ff62be.png";